module.exports = __webpack_public_path__ + "static/media/airFreight.94af11dd.jpg";